import {
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  Box,
  Autocomplete,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import {
  EditReport,
  FetchBranchShowData,
  FetchClassTypeShowData,
  FetchSectionShowData,
  FetchSemesterShowData,
  FetchSpecializationShowData,
  GetReportModification,
  GetSectionReport,
  GetStudentReportView,
  GetStudentWiseReportView,
  GetSubject,
  GetSubjectReport,
  LocationShowdata,
  ModificationStatus,
  SearchStudentOption,
} from "../../services/LoginPageService";
import { attendanceColor } from "../../utils/helperFunctions";
import {
  DownloadStudentReport,
  DownloadStudentWiseReport,
} from "../../services/DownloadCsvReportsService";
import NotificationBar from "../notification/ServiceNotificationBar";
import StudentReportTools from "../StudentReport/StudentReportTools";
import AttendanceDropdownEditCell from "./AttendanceDropdownEditCell";
import AttendenceModificationModel from "./AttendeceModificationModel";

const AttendenceModification = () => {
  const [month, setMonth] = useState("");
  const [toMonth, setToMonth] = useState("");
  const [location, setLocation] = useState("");
  const [locationList, setLocationList] = useState([]);
  const [branch, setBranch] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [specialization, setSpecialization] = useState("");
  const [specializationList, setSpecializationList] = useState([]);
  const [semester, setSemester] = useState("");
  const [semesterList, setSemesterList] = useState([]);
  const [subject, setSubject] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  const [section, setSection] = useState("");
  const [sectionList, setSectionList] = useState([]);
  const [rows, setRows] = useState([]);
  // const [rows, setRows] = useState(initialRows);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editClassName, setEditClassName] = useState("");
  const [downloadDisabled, setDownloadDisabled] = useState(true);
    const [modifiedDisabled, setModifiedDisabled] = useState(true);
  const [open, setOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [classTypedataList, setClassTypeDataList] = useState([]);
  const [classType, setClassType] = useState("");
  //  const [studentId,setStudentId]=useState('');
  const [studentOptions, setStudentOptions] = useState([]);
  const [studentId, setStudentId] = useState(null);
    const [dataset, setDataset] = useState([]);
  

  // const [status, remarks] = (params.value || "").split("|");
  // const colors = attendanceColor("", status);

  const [openNotification, setNotification] = useState({
    status: false,
    type: "error",
    message: "",
  });
  const columns = [
    {
      field: "registrationNo",
      headerName: "Registration No",
      type: "number",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "studentId",
      headerName: "Student Id",
      headerClassName: "super-app-theme--header",
      minWidth: 90,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "studentName",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "center",
    },
    {
      field: "subject",
      headerClassName: "super-app-theme--header",
      headerName: "Subject",
      minWidth: 100,
      flex: 1,
      align: "left",
      headerAlign: "center",
    },
    ...Array.from({ length: 31 }, (_, i) => ({
  field: `date${i + 1}`,
  headerName: `${i + 1}`,
  minWidth: 50,
  editable: true,
  flex: 1,
  align: "center",
  headerAlign: "center",
  renderCell: (params) => {
    const value = params.value || "";
    const [status, remarks] = value.split("|");
    const colors = attendanceColor("", value);

    if (Array.isArray(colors)) {
      const parts = value.split("/");
      return (
        <div
          style={{
            display: "flex",
            gap: "2px",
            justifyContent: "center",
          }}
        >
          {parts.map((part, idx) => (
            <Typography
              key={idx}
              component="span"
              style={{ color: colors[idx], fontWeight: "bold" }}
            >
              {part}
            </Typography>
          ))}
        </div>
      );
    }

    return (
      <Typography
        component="span"
        style={{
          color: colors,
          cursor: "pointer",
          display: "inline-block",
          width: "100%",
        }}
      >
        {status || "-"}
      </Typography>
    );
  },
  renderEditCell: (params) => <AttendanceDropdownEditCell {...params} />,
})),

    // Summary columns
    {
      field: "present",
      headerName: "Present",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "absent",
      headerName: "Absent",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "present%",
      headerName: "Percentage",
      type: "number",
      sortable: true,
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        return `${params.value}%`;
      },
    },
  ];
  useEffect(() => {
    LocationShowdata(handleLocationshow, handleLocationshowException);
    FetchClassTypeShowData(handleTypeSuccess, handleTypeException);
  }, [refreshData]);
  const handleTypeSuccess = (dataObject) => {
    setClassTypeDataList(dataObject.data);
  };

  const handleTypeException = () => {};
  const handleLocationshow = (dataObject) => {
    setLocationList(dataObject?.data);
    console.log(dataObject?.data);
  };

  const handleLocationshowException = (error, errorMessage) => {
    console.log(errorMessage);
  };

  const onLocationChange = (e) => {
    setLocation(e.target.value);
    FetchBranchShowData(
      { id: e.target.value },
      handleBranchSuccess,
      handleBranchException
    );
  };

  const handleBranchSuccess = (dataObject) => {
    setBranchList(dataObject.data);
  };

  const handleBranchException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  const onBranchChange = (e) => {
    setBranch(e.target.value);
    FetchSpecializationShowData(
      { id: e.target.value },
      handleSpecializationSuccess,
      handleSpecializationException
    );
  };

  const handleSpecializationSuccess = (dataObject) => {
    setSpecializationList(dataObject.data);
  };

  const handleSpecializationException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  const onSpecializationChange = (e) => {
    setSpecialization(e.target.value);
    FetchSemesterShowData(
      { id: e.target.value },
      handleSemesterSuccess,
      handleSemesterException
    );
  };

  const handleSemesterSuccess = (dataObject) => {
    setSemesterList(dataObject.data);
  };

  const handleSemesterException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  const onSemesterChange = (e) => {
    setSemester(e.target.value);
    GetSectionReport(
      {
        branch: branch,
        specialization: specialization,
        semester: e.target.value,
      },
      handleSectionSuccess,
      handleSectionException
    );
  };

  const handleSectionSuccess = (dataObject) => {
    setSectionList(dataObject.data);
  };

  const handleSectionException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
  };

  const onSectionChange = (e) => {
    setSection(e.target.value);
    SearchStudentOption(
      {
        location: location,
        semester: semester,
        sectionId: e.target.value, // section ID
      },
      handleSearchSuccess,
      handleSearchException
    );
  };

  const handleSearchSuccess = (dataObject) => {
    // Map API data to Autocomplete options
    const formattedOptions = dataObject.data.map((student) => ({
      label: student.studentName, // display name
      value: student.studentId, // actual ID
    }));
    setStudentOptions(formattedOptions);
  };

  const handleSearchException = (errorStatus, errorMessage) => {
    console.log(errorMessage);
  };

  const onClassTypeChange = (e) => {
    setClassType(e.target.value);
    // onclassTypeChange(e.target.value);
  };
  const handleClickOpen = () => {
  console.log('open to success');
  setOpen(true);
ModificationStatus(
    { section:section,
    monthFrom: month},
    ModificationStatusSuccess,
    ModificationStatusException
  );}
 const ModificationStatusSuccess = (dataObject) => {
          console.log('dataSet' , dataObject.data);
        setDataset(dataObject?.data || []);
       
    }
     const ModificationStatusException= (errorStaus, errorMessage) =>{
        console.log(errorMessage);
    }
  const handleClose = () => {
        setOpen(false);
    };
  const onStudentViewReport = () => {
    GetReportModification(
      {
        monthFrom: month,
        location: location,
        branch: branch,
        specialization: specialization,
        semester: semester,
        section: section,
        studentId: studentId,
        classType: classType,
      },
      handleStudentWiseReportView,
      handleStudentWiseReportViewException
    );
  };

  const handleStudentWiseReportView = (dataObject) => {
    setRows(dataObject || []);
    setDownloadDisabled(false);
    setModifiedDisabled(false);
  };

  const handleStudentWiseReportViewException = (errorStaus, errorMessage) => {
    console.log(errorMessage);
    setNotification({
      status: true,
      type: "error",
      message: errorMessage,
    });
  };
  // const handleAttendanceEdit = (newRow, oldRow) => {
  //   const changedField = Object.keys(newRow).find(
  //     (key) => newRow[key] !== oldRow[key] && key.startsWith("date")
  //   );

  //   if (!changedField) return oldRow;

  //   const payload = {
  //     studentId: newRow.studentId,
  //     subjectId: newRow.subjectId, // Ensure this exists in row
  //     date: changedField,
  //     monthFrom: month, // from state
  //     changeAttan: newRow[changedField],
  //       location: location,
  //       branch: branch,
  //       specialization: specialization,
  //       semester: semester,
  //       section: section,
  //       remarks: remarks
  //   };

  //   EditReport(
  //     payload,
  //     () => {
  //       setNotification({
  //         status: true,
  //         type: "success",
  //         message: "Attendance updated successfully.",
  //       });
  //     },
  //     (errorStatus, errorMessage) => {
  //       console.log(errorMessage);
  //       setNotification({
  //         status: true,
  //         type: "error",
  //         message: errorMessage || "Attendance update failed.",
  //       });
  //     }
  //   );
  //   GetReportModification(
  //     {
  //       monthFrom: month,
  //       location: location,
  //       branch: branch,
  //       specialization: specialization,
  //       semester: semester,
  //       section: section,
  //       studentId: studentId,
  //       classType: classType,
  //     },
  //     handleStudentWiseReportView,
  //     handleStudentWiseReportViewException
  //   );
  //   return newRow;
  // };
const handleAttendanceEdit = (newRow, oldRow) => {
  const changedField = Object.keys(newRow).find(
    (key) => newRow[key] !== oldRow[key] && key.startsWith("date")
  );

  if (!changedField) return oldRow;

  const [statusVal, remarksVal] = (newRow[changedField] || "").split("|");

  const payload = {
    studentId: studentId,
    subjectId: newRow.subjectId,
    date: changedField,
    monthFrom: month,
    changeAttan: statusVal,
    location,
    branch,
    specialization,
    semester,
    section,
    remarks: remarksVal || ""
  };

  EditReport(
    payload,
    () => {
      setNotification({
        status: true,
        type: "success",
        message: "Attendance updated successfully.",
      });
      GetReportModification(
        {
          monthFrom: month,
          location,
          branch,
          specialization,
          semester,
          section,
          studentId: newRow.studentId,
          classType,
        },
        handleStudentWiseReportView,
        handleStudentWiseReportViewException
      );
    },
    (errorStatus, errorMessage) => {
      setNotification({
        status: true,
        type: "error",
        message: errorMessage || "Attendance update failed.",
      });
    }
  );

  return newRow;
};

  // const onClickDownloadReport = () => {
  //   DownloadStudentWiseReport(
  //     {
  //       monthFrom: month,
  //       monthTo: toMonth,
  //       location: location,
  //       branch: branch,
  //       specialization: specialization,
  //       semester: semester,
  //       section: section,
  //       studentId: studentId,
  //       classType: classType,
  //     },
  //     handleStudentWiseDownload,
  //     handleStudentWiseDownloadException
  //   );
  // };

  // const handleStudentWiseDownload = () => {};

  // const handleStudentWiseDownloadException = () => {};

  const handleCloseNotify = () => {
    setNotification({
      status: false,
      type: "",
      message: "",
    });
  };
  //      const handleRowUpdate = (newRow, oldRow) => {
  //   // Optional: Validate or transform the new row before saving
  //   return newRow; // Return the updated row
  // };
  const handleRowUpdate = (newRow) => {
    const updatedRows = rows.map((row) =>
      row.id === newRow.id ? newRow : row
    );
    setRows(updatedRows);
    return newRow;
  };

  return (
    <div
      style={{
        height: 870,
        width: "98%",
        marginLeft: "5px",
        marginTop: "10px",
        overflow: "scroll",
        marginRight: "10px",
      }}
    >
      <Box
        sx={{
          mb: "10px",
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <Typography sx={{ m: 1 }} variant="h5">
          Attendence Modification
        </Typography>
        <Box sx={{ m: 1 }}></Box>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <TextField
            fullWidth
            label="Month "
            placeholder="Month"
            variant="outlined"
            required
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Location
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Select Location"
              placeholder="Select Location"
              required
              value={location}
              onChange={(e) => onLocationChange(e)}
            >
              {locationList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.location}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Course</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Select Branch"
              placeholder="Select Branch"
              requiredvalue={branch}
              onChange={(e) => onBranchChange(e)}
            >
              {branchList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Course</em>
                </MenuItem>
              ) : (
                <MenuItem value="" key={0}>
                  <em>Select Location </em>
                </MenuItem>
              )}
              {branchList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.branch}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Specialization
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Select Specialization"
              placeholder="Select Specialization"
              value={specialization}
              required
              onChange={(e) => onSpecializationChange(e)}
            >
              {specializationList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Specialization</em>
                </MenuItem>
              ) : (
                <MenuItem value="" key={0}>
                  <em>Select Course </em>
                </MenuItem>
              )}
              {specializationList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.specialization}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Semester
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Select Semester"
              placeholder="Select Semester"
              required
              value={semester}
              onChange={(e) => onSemesterChange(e)}
            >
              {semesterList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Year</em>
                </MenuItem>
              ) : (
                <MenuItem value="" key={0}>
                  <em>Select Specialization </em>
                </MenuItem>
              )}
              {semesterList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.semester}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Section</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Section"
              placeholder="Section"
              value={section}
              required
              onChange={(e) => onSectionChange(e)}
            >
              {sectionList.length !== 0 ? (
                <MenuItem value="" key={0}>
                  <em>Select Section</em>
                </MenuItem>
              ) : (
                <MenuItem value="" key={0}>
                  <em>Select Semester </em>
                </MenuItem>
              )}
              {sectionList?.map((data, index) => {
                return (
                  <MenuItem value={data.id} key={index}>
                    {data.section}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
          <Autocomplete
            disablePortal
            options={studentOptions}
            value={
              studentOptions.find((opt) => opt.value === studentId) || null
            }
            onChange={(event, newValue) => {
              setStudentId(newValue ? newValue.value : null);
            }}
            sx={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Student Name"
                placeholder="Student Name"
                variant="outlined"
                required
                inputProps={{
                  ...params.inputProps,
                  pattern: "^[0-9]*$",
                }}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing={1}
        mt={1}
      >
        <Grid item>
          {/* <Button
            variant="contained"
            disabled={downloadDisabled}
            onClick={onClickDownloadReport}
          >
            DownLoad
          </Button> */}
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={onStudentViewReport}>
            View
          </Button>
          {/* onClick={onViewReport} */}
        </Grid>
         <Grid item>
          <Button variant="contained" disabled={modifiedDisabled} onClick={handleClickOpen}>
            Modified Log 
          </Button>
          {/* onClick={onViewReport} */}
        </Grid>
      </Grid>
      
      <Grid style={{ marginTop: "20px" }}>
        
        <DataGrid
          rows={rows}
          columns={columns}
          processRowUpdate={handleAttendanceEdit}
          experimentalFeatures={{ newEditingApi: true }}
          pageSize={10}
          rowsPerPageOptions={[20]}
          disableSelectionOnClick
          getRowClassName={(params) =>
            Object.values(params.row).some(
              (value) => typeof value === "string" && value.includes("|")
            )
              ? "edited-row"
              : ""
          }
          sx={{
            height: "100%",
            minHeight: "480px",
            width: "100%",
            "& .edited-row": {
              backgroundColor: "#e3f2fd", // light blue for edited rows
            },
          }}
        />
      </Grid>
      <NotificationBar
        handleClose={handleCloseNotify}
        notificationContent={openNotification.message}
        openNotification={openNotification.status}
        type={openNotification.type}
      />
       <AttendenceModificationModel open={open} handleClose={handleClose} dataSet={dataset}/>
    </div>
  );
};

export default AttendenceModification;
